import { render } from "./Badge.vue?vue&type=template&id=3ae4fe04&scoped=true&ts=true"
import script from "./Badge.vue?vue&type=script&lang=ts"
export * from "./Badge.vue?vue&type=script&lang=ts"

import "./Badge.vue?vue&type=style&index=0&id=3ae4fe04&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae4fe04"]])

export default __exports__